import { JobBoardsVacanciesApplicationStatusEnum } from 'generated/api'
import { TVariant } from 'components/badge/Badge'

export default function jobVacancyParticipantStatusBadgeVariant(
  status: JobBoardsVacanciesApplicationStatusEnum,
): TVariant {
  switch (status) {
    case JobBoardsVacanciesApplicationStatusEnum.Accepted:
      return 'success'
    case JobBoardsVacanciesApplicationStatusEnum.Pending:
      return 'warning'
    case JobBoardsVacanciesApplicationStatusEnum.Rejected:
      return 'error'
    default:
      return 'info'
  }
}
